import $ from "jquery";
import {GPProjectView} from "./gp-projectview.js";
import {GPContextLabels} from "./gp-context-labels.js";
import {GPLabel} from "./gp-label.js";
import {
    season,
    mode,
    selectedItemSet,
    lightDirection
} from "./gp.js";
import {GPPlant} from "./gp-plant.js";
import {GPStructure} from "./gp-structure.js";
import {GPCustomObject} from "./gp-customobject.js";
import {get, writable} from 'svelte/store';
import {GPStructure3D} from "./gp-structure3d";
import {GPTypeCustomStructure} from "./gp-typecustomstructure";
import {GPTypePlant} from "./gp-typeplant";
import {GPTypeStructure} from "./gp-typestructure";
import {GPTypeItem} from "./gp-typeitem";

export let activePickerItem = writable(null); //in picker
export let activePickerStructureVariant = writable(null); //in structure picker only {h: number, s: number, v: number}; range as in gp-hsvadjust.svelte
export let activePickerSnippet = writable(null);
export let snippetFlip = writable(false);

export let GPContextItems = {
    plantLayer: null,
    renderedSeason: null,
    renderedLightDir: null,
    projectviewClick: null,
    storesInitiated: false,

    init: function (plantLayer) {
        GPContextItems.plantLayer = plantLayer;
        GPContextItems.plantLayer.listening(false);

        $( ".GPProjectView" ).droppable({
              drop: GPContextItems.addItemHandler
        });

        if (!GPContextItems.storesInitiated) {
            var func = function(ev, itemId) {
                GPContextItems.removeItemImage(itemId);
            };
            $(document).off('GPItemRemoved', func).on('GPItemRemoved', func);

            let func2 = function(ev, item) {
                item.repositionItem();
                GPContextItems.resortItems();
            };
            $(document).off('GPItemEdited', func2).on('GPItemEdited', func2);

            let func3 = async function(ev, item) {
                await item.redraw();
                item.repositionItem();
                GPContextItems.resortItems();
                GPContextItems.refreshItemHighlights([item]);
            };
            $(document).off('GPItemHardEdited', func3).on('GPItemHardEdited', func3);

            $(document).off('GPPlantsHardEdited', GPContextItems.refreshPlantsImages).on('GPPlantsHardEdited', GPContextItems.refreshPlantsImages);

            season.subscribe((s) => {
                if (s !== GPContextItems.renderedSeason) {
                    GPContextItems.refreshPlantsImages();
                    GPContextItems.renderedSeason = s;
                }
            });
            lightDirection.subscribe((l) => {
                if (l != GPContextItems.renderedLightDir) {
                    GPContextItems.refreshPlantsImages();
                    GPContextItems.refreshStructure3DImages();
                    GPContextItems.renderedLightDir = l;
                }
            });
            mode.subscribe((m) => {
                if ((m === "Plants" || m === "Structures" || m === "Snippets" || m === "Custom") && !GPContextItems.plantLayer.listening())
                    GPContextItems.activate();
                if ((m !== "Plants" && m !== "Structures" && m !== "Snippets" && m !== "Custom") && GPContextItems.plantLayer.listening())
                    GPContextItems.deactivate()

                if (m === "Plants" || m === "Structures" || m === "Snippets" || m === "Custom" || m === "Textures")
                    GPContextItems.showNormal();
                if (m === "FixedCutter")
                    GPContextItems.showFixedOnly();
                if (m === "Cloner" || m === "Inpainting")
                    GPContextItems.hideAll();

            })
            selectedItemSet.subscribe(GPContextItems.refreshItemHighlights);
            GPContextItems.storesInitiated = true;
        }
    },

    start: (e) => {
        let p =  GPProjectView.getPointerPosition(e);
        GPContextItems.projectviewClick = {x: p.x, y: p.y, type: e.target.nodeType}
    },
    end: (e) => {
        let p =  GPProjectView.getPointerPosition(e);
        if (p && GPContextItems.projectviewClick &&
            GPContextItems.projectviewClick.type === "Stage" &&
            Math.abs(p.x - GPContextItems.projectviewClick.x) < 5 &&
            Math.abs(p.y - GPContextItems.projectviewClick.y) < 5)
                GPContextItems.addItemHandler(e)
        GPContextItems.projectviewClick = null;
        GPProjectView.selectionRect.visible(false);
        GPProjectView.setCursor();
    },
    move: (e) => {
        let p =  GPProjectView.getPointerPosition(e);
        if (p && GPContextItems.projectviewClick &&
            GPContextItems.projectviewClick.type === "Stage" &&
            (Math.abs(p.x - GPContextItems.projectviewClick.x) > 5 ||
             Math.abs(p.y - GPContextItems.projectviewClick.y) > 5))
            GPContextItems.rectSelect(p.x, p.y, GPContextItems.projectviewClick.x, GPContextItems.projectviewClick.y);
    },

    activate: function() {
        GPProjectView.stage.off('mousedown touchstart', GPContextItems.start).on('mousedown touchstart', GPContextItems.start);
        $('body').off('mouseup touchend', GPContextItems.end).on('mouseup touchend', GPContextItems.end);
        GPProjectView.stage.off('mousemove touchmove', GPContextItems.move).on('mousemove touchmove', GPContextItems.move);

        $(document).off("keydown", GPContextItems.handleKeyboard).on("keydown", GPContextItems.handleKeyboard);
        GPContextItems.plantLayer.listening(true);
    },

    deactivate: function() {
        GPProjectView.stage.off('mousedown touchstart', GPContextItems.start);
        $('body').off('mouseup touchend', GPContextItems.end);
        GPProjectView.stage.off('mousemove touchmove', GPContextItems.move)

        $(document).off("keydown", GPContextItems.handleKeyboard);
        GPContextItems.plantLayer.listening(false);
    },

    addItemHandler: function (event) {
        let m = get(mode);
        if (m === "Plants" && !(get(activePickerItem) instanceof GPTypePlant))
            return;
        if (m === "Structures" && !(get(activePickerItem) instanceof GPTypeStructure))
            return;
        if (m === "Snippets" && !get(activePickerSnippet))
            return;

        var pos = GPProjectView.getPointerPosition(event);
        if (pos.x < 0 || pos.y < 0 || pos.x > GPProjectView.width || pos.y > GPProjectView.height)
            return;

        GP.showWaiting();

        var p = GPProjectView.coordsViewToProject(pos.x, pos.y);

        if (m === "Plants" || m === "Structures") {
            GPContextItems.addItemAtPos(p);
            selectedItemSet.set([]);
        }

        if (m === "Snippets") {
            //Dont allow drawing above horizon
            if (p.y < (1-GP.project.horizonPos)*GP.project.sizeY) {
                GPProjectView.showHorizonHint();
            } else {
                let newPlants = GPContextItems.addSnippetAtPos(p);
                selectedItemSet.set(newPlants);
            }
        }

    },

    addItemAtPos: function(p) {
        let m = get(mode);
        var itemInstance;
        if (m === "Plants") {
            itemInstance = GP.project.addPlant(get(activePickerItem).id, p.x, p.y, 1);
        }
        if (m === "Structures" && !(get(activePickerItem) instanceof GPTypeCustomStructure)) {
            itemInstance = GP.project.addStructure(get(activePickerItem).id, p.x, p.y, 1, 1, get(activePickerStructureVariant));
        }
        if (m === "Structures" && get(activePickerItem) instanceof GPTypeCustomStructure) {
            itemInstance = GP.project.addCustom(get(activePickerItem).id, p.x, p.y, 1, false);
        }
        GP.saveUndo("addItem", itemInstance);

        GPContextItems.addItemInstanceToView(itemInstance);

        return itemInstance;
    },

    addItemAtDefaultPos: function() {
        var p = GPProjectView.coordsViewToProject(GPProjectView.width/2, 4*GPProjectView.height/5);
        var itemInstance = GPContextItems.addItemAtPos(p);
        selectedItemSet.set([itemInstance]);
        GP.storeFocus();
        $(".GPProjectView").focus();
    },

    addItemInstanceToView: function(itemInstance) {
        return new Promise(function(resolve, reject) {
            let ses = get(season);
            if (itemInstance.supportsThumb) {
                //thumb first
                itemInstance.createDisplayObject(ses, true).then(function (konvaObject) {
                    GPContextItems.addKonvaImageObject(itemInstance, konvaObject);

                    //now actual image
                    itemInstance.createDisplayObject(ses, false).then(function (konvaObject) {
                        GPContextItems.addKonvaImageObject(itemInstance, konvaObject);
                        resolve();
                    });
                });
            }
            else {
                itemInstance.createDisplayObject(ses, false).then(function (konvaObject) {
                    GPContextItems.addKonvaImageObject(itemInstance, konvaObject);
                    resolve();
                });
            }
        });
    },

    addSnippetAtPos: function(p, snip) {
        let snippet = snip ? snip : get(activePickerSnippet);
        let newPlants = [];

        let originalHorizonScaleFactor = GPTypeItem.scaleAccordingToHorizon(snippet.y, snippet.reference.sizeY, snippet.reference.horizonPos, snippet.reference.designWidth, snippet.reference.sizeX);
        let destHorizonScaleFactor = GPTypeItem.scaleAccordingToHorizon(p.y);

        let orgRelDistToHorizFactor = (snippet.y - (1 - snippet.reference.horizonPos) * snippet.reference.sizeY) / originalHorizonScaleFactor;
        let destRelDistToHorizFactor = (p.y - (1 - GP.project.horizonPos) * GP.project.sizeY) / destHorizonScaleFactor;

        let refl = get(snippetFlip) ? -1 : 1;
        snippet.plants.forEach(el => {
            let neighbouighDistanceX = el.itemInstance.x - snippet.x;
            let neighbouighDistanceY = el.itemInstance.y - snippet.y;

            let newNeighbouighDistanceX = refl * neighbouighDistanceX * destHorizonScaleFactor/originalHorizonScaleFactor;
            let newNeighbouighDistanceY = neighbouighDistanceY * destHorizonScaleFactor/originalHorizonScaleFactor * destRelDistToHorizFactor / orgRelDistToHorizFactor;

            let itemInstance = GP.project.addPlant(el.itemInstance.typeId, p.x + newNeighbouighDistanceX, p.y + newNeighbouighDistanceY, el.itemInstance.s);
            GPContextItems.addItemInstanceToView(itemInstance);
            newPlants.push(itemInstance);
        })

        GP.saveUndo("addItems", newPlants);
        return newPlants;
    },

    addSnippetAtDefaultPos: function(snip) {
        var p = GPProjectView.coordsViewToProject(GPProjectView.width/2, 4*GPProjectView.height/5);
        var itemInstances = GPContextItems.addSnippetAtPos(p, snip);
        selectedItemSet.set(itemInstances);
        GP.storeFocus();
        $(".GPProjectView").focus();
    },


    removeItemImage: function (itemId) {
        var image = GPProjectView.stage.find('#' + itemId)[0];
        if (image) {
            image.destroy();
        }
    },

    repositionItems: function () {
        for (var p in GP.project.items) {
            var inst = GP.project.items[p];
            if (inst instanceof GPPlant || inst instanceof GPStructure || inst instanceof GPCustomObject )
            inst.repositionItem();
        }
    },

    resortItems: function () {
        GP.project.resortItems();
        for (var p in GP.project.items) {
            var itemInstance = GP.project.items[p];

            var id = itemInstance.id;

            var image = GPProjectView.stage.find('#' + id)[0];
            if (image)
                image.setZIndex(itemInstance.zindex);
        }
    },

    rectSelect: function(x1, y1, x2, y2) {
        [x1, x2] = x1 > x2 ? [x2, x1] : [x1, x2];
        [y1, y2] = y1 > y2 ? [y2, y1] : [y1, y2];

        let p1 = GPProjectView.coordsViewToProject(x1, y1);
        let p2 = GPProjectView.coordsViewToProject(x2, y2);

        let set = GP.project.items.filter(i =>
            p1.x <= i.x && i.x <= p2.x &&
            p1.y <= i.y && i.y <= p2.y
        )
        selectedItemSet.set(set)

        GPProjectView.selectionRect.x(x1);
        GPProjectView.selectionRect.y(y1);
        GPProjectView.selectionRect.width(x2 - x1);
        GPProjectView.selectionRect.height(y2 - y1);
        GPProjectView.selectionRect.visible(true);
        GPProjectView.setCursor("standard");
    },

    /**
     * Hide all plants/structures - switch to the mode required for "cutting" "fixed" objects from background
     */
    showFixedOnly: function () {
        for (var p in GP.project.items) {
            var itemInstance = GP.project.items[p];

            var id = itemInstance.id;

            var image = GPProjectView.stage.find('#' + id)[0];
            if (image) {
                image.visible(itemInstance.fixedObject === true);
                if (!(itemInstance instanceof GPLabel)) {
                    image.shadowEnabled(true);
                    image.cache();
                    image.drawHitFromCache();
                }
            }
        }
    },

    /**
     * Hide all plants/structures - switch to the mode required for "cloning" background
     */
    hideAll: function () {
        for (var p in GP.project.items) {
            var itemInstance = GP.project.items[p];

            var id = itemInstance.id;

            var image = GPProjectView.stage.find('#' + id)[0];
            if (image) {
                image.visible(false);
            }
        }
    },

    /**
     * Show plants/structures - switch to the normal view mode
     */
    showNormal: function () {
        for (var p in GP.project.items) {
            var itemInstance = GP.project.items[p];

            var id = itemInstance.id;

            var image = GPProjectView.stage.find('#' + id)[0];
            if (image) {
                image.visible(true);
                if (!(itemInstance instanceof GPLabel)) {
                    image.shadowEnabled(false);
                    image.cache();
                    image.drawHitFromCache();
                }
            }
        }
    },
    
    refreshItemHighlights: function (itemInstances) {
        GP.project.items.forEach((item) => {
            let highlighted = false;
            for (let i in (itemInstances)) {
                if (item === itemInstances[i] || (item.originItemInstance && item.originItemInstance === itemInstances[i])) {
                    highlighted = true;
                    break;
                }
            }
            item.setHighlight(highlighted);
        })
    },

    refreshPlantsImages: function () {
        GP.showWaiting();

        Promise.all(GP.project.items.filter(function(item) {
            return item instanceof GPPlant
        }).map(GPContextItems.addItemInstanceToView)).then(function() {
            GP.clearWaiting();
        });
    },

    refreshStructure3DImages: function () {
        GP.showWaiting();

        Promise.all(GP.project.items.filter(function(item) {
            return item instanceof GPStructure3D
        }).map(GPContextItems.addItemInstanceToView)).then(function() {
            GP.clearWaiting();
        });
    },

    addKonvaImageObject: function (itemInstance, ko) {
        //in case we're swapping element from thumb to full res - remove previous image
        GPContextItems.removeItemImage(itemInstance.id);

        if (!itemInstance.fixedObject) {
            let initialDragOffsetX;
            let initialDragOffsetY;
            /**
             * @type {"moveItem"|"cloneItem"}
             */
            let dragMode = "moveItem";
            let dragClones = [];
            let draggedItemsOriginalPositions = [];

            // Function to handle mode switching
            const updateDragMode = (event) => {
                if (event.metaKey || event.ctrlKey || (event.evt && event.evt.metaKey) || (event.evt && event.evt.ctrlKey)) {
                    if (dragMode !== "cloneItem") {
                        dragMode = "cloneItem";
                        let movedSet = get(selectedItemSet);
                        if (!movedSet.length) movedSet = [itemInstance];
                        movedSet.forEach(item => {
                            let itemImg = GPProjectView.stage.find('#' + item.id)[0];
                            let clonedImage = itemImg.clone();
                            clonedImage.position({x: draggedItemsOriginalPositions.find(k => k.itemId === item.id).x,
                                                y: draggedItemsOriginalPositions.find(k => k.itemId === item.id).y});
                            dragClones.push(clonedImage);
                            GPContextItems.plantLayer.add(clonedImage);
                        });
                        GPProjectView.stage.draw();
                    }
                } else {
                    if (dragMode !== "moveItem") {
                        dragMode = "moveItem";
                        // Clean up clones when switching back to move mode
                        dragClones.forEach(ko => {
                            ko.destroy();
                        });
                        dragClones = [];
                        GPProjectView.stage.draw();
                    }
                }
            };

            ko.on("dragstart", function (event) {
                event.cancelBubble = true;
                initialDragOffsetX = event.target.attrs.x;
                initialDragOffsetY = event.target.attrs.y;

                // Store original positions of dragged items for potential cloning
                let movedSet = get(selectedItemSet);
                if (!movedSet.length) movedSet = [itemInstance];
                draggedItemsOriginalPositions = movedSet.map(item => {
                    let itemImg = GPProjectView.stage.find('#' + item.id)[0];
                    return {
                        itemId : item.id,
                        x: itemImg.x(),
                        y: itemImg.y()
                }});

                // Initialize mode based on whether the ctrl/meta key is pressed at the start
                updateDragMode(event);

                // Add keydown and keyup listeners to detect mode switching during drag
                window.addEventListener('keydown', updateDragMode);
                window.addEventListener('keyup', updateDragMode);

            });

            ko.on("dragend", function (event) {
                event.cancelBubble = true;
                var itemInstance = GP.project.itemsById[event.target.attrs.id];
                var x = event.target.attrs.x + event.target.width() / 2;
                var y = event.target.attrs.y + event.target.height();
                if (itemInstance.horizontalFlip < 0)
                    x = x - event.target.width();
                let xShift = itemInstance.xShift * event.target.width() / itemInstance.imageWidth;
                x = x - xShift;
                var p = GPProjectView.coordsViewToProject(x, y);

                let movedSet = get(selectedItemSet);
                //if we move object that is not selection set, only that object should be moved
                if (movedSet.indexOf(itemInstance)<0) movedSet = [itemInstance];

                let originalHorizonScaleFactor = itemInstance.scaleAccordingToHorizon(itemInstance.y);
                let destHorizonScaleFactor = itemInstance.scaleAccordingToHorizon(p.y);
                let movedItemOriginalX = itemInstance.x;
                let movedItemOriginalY = itemInstance.y;

                if (dragMode === "cloneItem") {
                    let addedItems = [];
                    movedSet.forEach(item => {
                        let neighbouighDistanceX = item.x - movedItemOriginalX;
                        let neighbouighDistanceY = item.y - movedItemOriginalY;

                        let newNeighbouighDistanceX = neighbouighDistanceX * destHorizonScaleFactor/originalHorizonScaleFactor;
                        let newNeighbouighDistanceY = neighbouighDistanceY * destHorizonScaleFactor/originalHorizonScaleFactor;

                        let itemInstance = GP.project.cloneItem(item.id, GP.cloningOffset);
                        if (itemInstance) { //Labels are currently not clonable, co we need to check if cloning was successful
                            itemInstance.x = p.x + newNeighbouighDistanceX;
                            itemInstance.y = p.y + newNeighbouighDistanceY;

                            addedItems.push(itemInstance);
                            GPContextItems.addItemInstanceToView(itemInstance);
                        }
                    })
                    GP.saveUndo("addItems", addedItems);
                    selectedItemSet.set(addedItems);

                    // Clean up drag clones
                    dragClones.forEach(ko => {
                        ko.destroy();
                    });
                    dragClones = [];
                    GPContextItems.repositionItems();

                } else {
                    //move
                    GP.saveUndo("modifyItems", movedSet);
                    movedSet.forEach(item => {
                        let neighbouighDistanceX = item.x - movedItemOriginalX;
                        let neighbouighDistanceY = item.y - movedItemOriginalY;

                        let newNeighbouighDistanceX = neighbouighDistanceX * destHorizonScaleFactor/originalHorizonScaleFactor;
                        let newNeighbouighDistanceY = neighbouighDistanceY * destHorizonScaleFactor/originalHorizonScaleFactor;

                        GP.project.moveItem(item.id, p.x + newNeighbouighDistanceX , p.y + newNeighbouighDistanceY);
                    })
                }

                // Remove key listeners after drag ends
                window.removeEventListener('keydown', updateDragMode);
                window.removeEventListener('keyup', updateDragMode);
            });

            ko.on("dragmove", function (event) {
                var itemInstance = GP.project.itemsById[event.target.attrs.id];

                //drag along other selected objects
                let dragOffsetX = event.target.attrs.x - initialDragOffsetX;
                let dragOffsetY = event.target.attrs.y - initialDragOffsetY;

                let movedSet = get(selectedItemSet);
                //if we move object that is not selection set, only that object should be moved
                if (movedSet.indexOf(itemInstance)<0) movedSet = [itemInstance];

                movedSet.forEach(item => {
                    if (event.target.attrs.id != item.id) {
                        let movedImage = GPProjectView.stage.find('#' + item.id)[0];
                        movedImage.setX( movedImage.x() + dragOffsetX);
                        movedImage.setY( movedImage.y() + dragOffsetY);
                    }
                })
                initialDragOffsetX = event.target.attrs.x;
                initialDragOffsetY = event.target.attrs.y;
                if (dragMode === "cloneItem")
                    GPProjectView.setCursor("addItem");
                else
                    GPProjectView.setCursor("movePlant");
            });

            ko.on("mouseover", function () {
                GPProjectView.setCursor("overPlant");
            });

            ko.on("mouseout", function () {
                GPProjectView.setCursor();
            });

            ko.on("click touchend", function (event) {
                event.cancelBubble = true;
                var itemInstance = GP.project.itemsById[event.target.attrs.id];
                if (event.evt.shiftKey && get(selectedItemSet).indexOf(itemInstance) < 0)
                    selectedItemSet.set([...get(selectedItemSet), itemInstance]);
                if (!event.evt.shiftKey)
                    selectedItemSet.set([itemInstance]);
            });
        }

        ko.cache();
        ko.drawHitFromCache();

        GPContextItems.plantLayer.add(ko);
        itemInstance.repositionItem();
        GPContextItems.resortItems();

        GP.clearWaiting();
    },

    onresize: function () {
        GPContextItems.repositionItems();
    },

    handleKeyboard: function (e) {
        if (!GPSettings.keyShortcutsNative ) {
            //paste
            if (e.key == "v" && (e.ctrlKey || e.metaKey)) {
                GP.pasteItems();
            }
            //copy
            if (e.key == "c" && (e.ctrlKey || e.metaKey)) {
                GP.copySelectedItems();
            }
            //cut
            if (e.key == "x" && (e.ctrlKey || e.metaKey)) {
                GP.cutSelectedItems();
            }
        }
        //Further actions only when project area active
        if ($(".GPProjectView.active").length) {
            switch (e.which) {
                case 37: // left
                    get(selectedItemSet).forEach(s => {
                        s.x -= 2;
                        GP.project.moveItem(s.id, s.x, s.y);
                    })
                    break;

                case 38: // up
                    get(selectedItemSet).forEach(s => {
                        s.y -= 2;
                        GP.project.moveItem(s.id, s.x, s.y);
                    })

                case 39: // right
                    get(selectedItemSet).forEach(s => {
                        s.x += 2;
                        GP.project.moveItem(s.id, s.x, s.y);
                    })
                    break;

                case 40: // down
                    get(selectedItemSet).forEach(s => {
                        s.y += 2;
                        GP.project.moveItem(s.id, s.x, s.y);
                    })
                    break;

                case 46: // del
                    GP.saveUndo("deleteItems", get(selectedItemSet).map( si => {return {itemInstance: si, type: si.constructor.name}} ));
                    get(selectedItemSet).forEach(s => {
                        GP.project.removeItem(s.id);
                    })
                    GP.restoreFocus();
                    selectedItemSet.set([]);
                    break;

                case 191: // ?
                    if (get(selectedItemSet).length)
                        GP.app.showDetailsOfItem(get(selectedItemSet)[0]);
                    break;

                case 27: // esc
                    selectedItemSet.set([]);
                    GP.restoreFocus();
                    break;

                case 107:
                case 187: // plus
                    GP.saveUndo("modifyItems", get(selectedItemSet));
                    get(selectedItemSet).forEach(s => {
                        GP.project.biggerItem(s.id);
                    })
                    break;

                case 109:
                case 189: // minus
                    GP.saveUndo("modifyItems", get(selectedItemSet));
                    get(selectedItemSet).forEach(s => {
                        GP.project.smallerItem(s.id);
                    })
                    break;

                default:
                    return; // exit this handler for other keys

                    e.preventDefault(); // prevent the default action (scroll / move caret)
            }
        }
    }


};

